const Breadcrumb = ({ breadcrumbs }) => {
  return (
    <div className="h-14 px-8">
      <div className="h-full w-full flex items-center">
        <div className="text-sm text-black/45" onClick={() => breadcrumbs[0].event && breadcrumbs[0].event()}>
          {breadcrumbs[0].title}
        </div>
        <div className="w-[22px] h-[22px] flex items-center justify-center text-black/45">/</div>
        <div className="text-sm text-gray-102" onClick={() => breadcrumbs[1].event && breadcrumbs[1].event()}>
          {breadcrumbs[1].title}
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
